import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

const getAuthHeaders = () => {
    const token = localStorage.getItem(UserKeys.TOKEN);
    return {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
};

export const getPlaylists = async () => {
    const response = await axios.get(`${API_URL}/playlist`, getAuthHeaders());
    return response.data;
};

export const updateActivePlaylists = async (playlistUuids) => {
    const response = await axios.put(`${API_URL}/playlist/activePlaylists`, { playlistUuids }, getAuthHeaders());
    return response.data;
};

export const createPlaylist = async (payload) => {
    const response = await axios.post(`${API_URL}/playlist`, payload, getAuthHeaders());
    return response.data;
};

export const updatePlaylist = async (uuid, payload) => {
    const response = await axios.put(`${API_URL}/playlist/${uuid}`, payload, getAuthHeaders());
    return response.data;
};

export const deletePlaylist = async (uuid) => {
    const response = await axios.delete(`${API_URL}/playlist/${uuid}`, getAuthHeaders());
    return response.data;
};

export const uploadPlaylistImage = async (file) => {
    const fileName = file.name || "playlist-image";
    const extension = fileName.includes(".") ? fileName.split(".").pop().toLowerCase() : "png";
    const presignedResponse = await axios.get(`${API_URL}/playlist/generateUrl/${extension}`, getAuthHeaders());
    const fullUrl = presignedResponse.data.url;
    const storedUrl = fullUrl.split("?")[0];

    await axios.put(fullUrl, file, {
        headers: {
            "Content-Type": file.type
        }
    });

    return storedUrl;
};
